'use client';

import React from 'react';

import classNames from 'classnames';

import { StaggerChildren } from '@/blocks/animations/AppearInView';
import { siteVersion } from '@/global/public-settings';

import { AboutPartnerItem } from '@/app/[lang]/about/sections/AboutPartnersSection/AboutPartnerItem/AboutPartnerItem';
import baksta from '@/app/[lang]/about/sections/AboutPartnersSection/assets/baksta.svg';
import crystal from '@/app/[lang]/about/sections/AboutPartnersSection/assets/crystal.svg';
import devexperts from '@/app/[lang]/about/sections/AboutPartnersSection/assets/devexperts.svg';
import fireblocks from '@/app/[lang]/about/sections/AboutPartnersSection/assets/fireblocks.svg';
import trview from '@/app/[lang]/about/sections/AboutPartnersSection/assets/trview.svg';

import styles from './styles.module.scss';

export type PartnerItem = {
  img: string;
  alt: string;
  link?: string;
};

const partnerItems: PartnerItem[] = siteVersion.isAfrica
  ? [
      {
        img: crystal,
        alt: 'Crystal',
      },
      {
        img: devexperts,
        alt: 'Devexperts',
      },
      {
        img: fireblocks,
        alt: 'Fireblocks',
      },
      {
        img: trview,
        alt: 'Review',
        link: 'https://www.tradingview.com/',
      },
    ]
  : [
      {
        img: crystal,
        alt: 'Crystal',
      },
      {
        img: devexperts,
        alt: 'Devexperts',
      },
      {
        img: baksta,
        alt: 'Baksta',
      },
      {
        img: fireblocks,
        alt: 'Fireblocks',
      },
      {
        img: trview,
        alt: 'Review',
        link: 'https://www.tradingview.com/',
      },
    ];

export const PartnersBlock = () => {
  return (
    <StaggerChildren className={siteVersion.isAfrica ? styles.wrapperItemsAfrica : styles.wrapperItems}>
      {partnerItems.map((item, key) => (
        <div key={key} className={classNames(styles.item)}>
          <AboutPartnerItem {...item} />
        </div>
      ))}
    </StaggerChildren>
  );
};
